module.exports = __webpack_public_path__ + "static/img/01.5ccc27e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/280319/01.png
// module id = IaL7
// module chunks = 0